export default {
  name: "WrapWithHighlight",
  emits: ['click'],
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean
    }
  }
};